import { render, staticRenderFns } from "./EditDate.vue?vue&type=template&id=5195b576&scoped=true&"
import script from "./EditDate.vue?vue&type=script&lang=js&"
export * from "./EditDate.vue?vue&type=script&lang=js&"
import style0 from "./EditDate.vue?vue&type=style&index=0&id=5195b576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5195b576",
  null
  
)

export default component.exports